import Box from '@mui/material/Box'
import type { SxProps, Theme } from '@mui/material/styles'

/** Path from public/assets/sidebar.svg */
const SIDEBAR_ICON_PATH =
	'M81 34C81 27.93 76.07 23 70 23H30C23.93 23 19 27.93 19 34V66C19 72.07 23.93 77 30 77H70C76.07 77 81 72.07 81 66V34ZM37 71H30C27.24 71 25 68.76 25 66V34C25 31.24 27.24 29 30 29H37V71ZM75 66C75 68.76 72.76 71 70 71H43V29H70C72.76 29 75 31.24 75 34V66Z'

function toDimension(size: string | number): string {
	return typeof size === 'number' ? `${size}px` : size
}

export function SidebarIcon({
	size: sizeProp,
	fontSize,
	sx,
}: {
	size?: string | number
	fontSize?: string | number
	sx?: SxProps<Theme>
}) {
	const size = toDimension(sizeProp ?? fontSize ?? 'var(--icon-fontSize-md)')

	return (
		<Box
			aria-hidden
			component="svg"
			fill="currentColor"
			viewBox="0 0 100 100"
			xmlns="http://www.w3.org/2000/svg"
			sx={{
				width: size,
				height: size,
				display: 'block',
				flexShrink: 0,
				...sx,
			}}
		>
			<path d={SIDEBAR_ICON_PATH} fill="currentColor" />
		</Box>
	)
}

/** @deprecated Use SidebarIcon */
export const SidebarExpandIcon = SidebarIcon

/** @deprecated Use SidebarIcon */
export const SidebarCollapseIcon = SidebarIcon
